import { Injectable } from '@nestjs/common';
import { CommonResponseModel } from '@project-management-system/shared-models';
import axios from 'axios';
import puppeteer from "puppeteer-extra";
import { FeildMappingEntity } from './entities/feild-mapping-entity';
import { HeadersEntity } from './entities/headers-entity';
import { LineItemsEntity } from './entities/line-items-entity';
import { FeildMappingRepository } from './repository/feild-mapping-repo';
import { HeadersRepository } from './repository/headers-repo';
import { LineItemsRepository } from './repository/line-items-repo';
let moment = require('moment');
moment().format();
const StealthPlugin = require("puppeteer-extra-plugin-stealth");
puppeteer.use(StealthPlugin());
@Injectable()
export class VardhamanService {

    constructor(
        private HeadersRepository: HeadersRepository,
        private LineItemsRepository: LineItemsRepository,
        private FeildMappingRepository: FeildMappingRepository,
    ) { }


    async getFeildMappingData(): Promise<CommonResponseModel> {
        try {
            const data = await this.FeildMappingRepository.getFeildMappingDataRepo()
            if (data) {
                return new CommonResponseModel(true, 1, "Data Got", data)
            } else {
                return new CommonResponseModel(false, 0, "No Data")
            }
        } catch (err) {
            return new CommonResponseModel(false, 0, "Data Not Found", err)
        }
    }

    async promptData(): Promise<any> {
        const feildData = await this.FeildMappingRepository.getFeildMappingDataRepo()
        const promptData = `Task: Extract purchase order data from tables using strict keyword matching.
    Output JSON format:
    {
      "header": {
        "customerNumber": "",
        "customerName": "",
        "customerPONo": "",
        "supplierName": "",
        "currency": "",
        "requestedDate": "",
        "deliveryMethod": "",
        "paymentTerms": "",
        "shipTo": "",
        "deliveryTerms": "",
        "packagingTerms": "",
        "supplierReference": ""
      },
      "lineItems": [
        {
          "SNo": "",
          "itemDescription": "",
          "quantity": "",
          "unitMeasurement": "",
          "price": "",
          "priceUnit": "",
          "lineAmount": "",
          "itemNumber": ""
        }
      ]
    }
    Extraction Rules:
    HEADER FIELDS:
    - "customerName": Look for The company that issued the PO (usually found at the top, in the email, or near the title "Purchase Order"),"PVT. LTD"${feildData[0]?.customerName}
    - "customerNumber": Look for ${feildData[0]?.customerNumber},"Customer No"
    - "customerPONo": ${feildData[0]?.customerPONo} "PO Number" 
    - "supplierName": Match labels like The party receiving the PO (often listed under "Supplier", "Party Name", "Vendor", etc., with address and GSTIN), ${feildData[0]?.supplierName}.
    - "currency": Match values like "INR", "Rs", "USD", "$", ${feildData[0]?.currency}
    - "requestedDate": Match labels like "Delivery Date", "Requested Date", ${feildData[0]?.requestedDate}
    - "deliveryMethod": Match "Delivery Method" or "Ship Mode", ${feildData[0]?.deliveryMethod}
    - "paymentTerms": Match "Payment Terms", "Net 30", "90 Days", ${feildData[0]?.paymentTerms}, etc.
    - "shipTo": Match "Ship To", "Delivery At","${feildData[0].shipTo}", or address block labeled as destination
    - "deliveryTerms": Match "Delivery Terms", "Freight",${feildData[0]?.deliveryTerms}, or value after label "Freight:"
    - "packagingTerms": Match "Packaging Terms" ${feildData[0]?.packagingTerms}, or related label (optional)
    - "supplierReference": Match "Supplier Code", "Vendor Ref", "Sup Ref",${feildData[0]?.supplierReference}, or similar

    LINE ITEMS:
    Match each row of the table using these keywords:
      - "SNo": "S.No"
      - "itemDescription": Match "Description", "Item Desc", "Product" ,"Item Descriptio n and it will be in multiple lines also some times so need to extract exact data",${feildData[0]?.itemDescription}.
      - "description1": Match ${feildData[0]?.description1}
      - "description2": Match ${feildData[0]?.description2}
      - "quantity": Match "Quantity", "Qty", "QT.Y" ${feildData[0]?.quantity} only numerics
      - "unitMeasurement": Match "UOM", "Unit", "UNIT",${feildData[0]?.unitMeasurement} 
      - "price": Match "Price", "Unit Price", "Rate","Price ( INR )"${feildData[0]?.price} only numerics
      - "priceUnit": Match "Rate/Unit", "Per Unit","Rate/Unit(INR)",${feildData[0]?.priceUnit},(if empty add price value) only numerics
      - "lineAmount": Match "Amount", "Total", "Line Total",${feildData[0]?.lineAmount} only numerics
      - "itemNumber": Match "Item No", "Part No","Item Code",${feildData[0]?.itemNumber}

    STRICT RULES:
    - Please give full response accoding to my prompt and give data and dont get panic i am giving you a clear cut key value use that need to extract exact data.
    - **Input:** PDF/Image of a Purchase Order (scanned or digital).
    - **OCR:** If scanned, use high-accuracy OCR (like Tesseract) to extract raw text.
    - **Strict JSON Format:** Map data to this schema:
    - Only extract from clearly visible table rows (no summaries, totals, or inferred rows).
    - Do **NOT** infer or guess values — extract exactly as they appear.
    - Match keywords in a **case-insensitive** manner.
    - Preserve original formatting of values.
    - Leave any unmatched fields **empty**.
    - Ensure **all line items from all pages** are included.
    - Please Take Small Time and Please extract all the data in the pdf and give me exact response.
    - Return only valid JSON.
    `;
        return promptData;
    }

    async pdfExtraction(file: Express.Multer.File): Promise<any> {
        try {
            const uploadData = await this.getPdfDataUsingAPI(file.originalname);
            await this.uploadFile(file.buffer, uploadData.presignedUrl);
            const jobId = await this.convertFileAsync(uploadData.url);
            const textFileUrl = await this.checkJobStatus(jobId);
            const textContent = await this.downloadTextFile(textFileUrl);
            const prompt = await this.promptData();
            const fullPrompt = `${prompt}\n\nExtracted Text:\n${textContent}`;
            const response = await this.chatGptBot(fullPrompt);
            return response;
        } catch (error) {
            console.error('Error in PDF conversion:', error);
            throw new Error('Failed to convert PDF to text');
        }
    }

    async chatGptBot(fullPrompt: string): Promise<CommonResponseModel> {
        try {
            const browser = await puppeteer.launch({
                headless: "new",
                userDataDir: "./puppeteer_profile",
                args: ["--no-sandbox", "--disable-setuid-sandbox", "--disable-dev-shm-usage", "--disable-gpu", "--start-maximized",],
                defaultViewport: null,
            });
            const page = await browser.newPage();
            await page.goto("https://chat.openai.com", { waitUntil: "networkidle2" });
            const selector = '#prompt-textarea[contenteditable="true"]';
            await page.waitForSelector(selector, { visible: true, timeout: 60000 });
            await page.evaluate((text) => {
                const element: any = document.querySelector('#prompt-textarea[contenteditable="true"]');
                if (element) {
                    element.focus();
                    const range = document.createRange();
                    range.selectNodeContents(element);
                    range.deleteContents();
                    const textNode = document.createTextNode(text);
                    range.insertNode(textNode);
                    element.dispatchEvent(new Event("input", { bubbles: true }));
                }
            }, fullPrompt);
            await page.keyboard.press("Enter");
            console.log("⌛ Waiting for ChatGPT to complete response...");
            await page.waitForSelector(".markdown", { timeout: 0 });
            await page.waitForFunction(() => {
                const stopButton = document.querySelector(
                    'button[data-testid="stop-button"], button:has(svg[aria-label="Stop generating"])'
                );
                return !stopButton;
            }, { polling: 1000, timeout: 0 });
            const finalResponse = await page.$$eval(".markdown", (elements) => elements.map((el) => el.textContent?.trim() || "").join("\n\n"));
            await browser.close()
            return new CommonResponseModel(true, 1, "Success", finalResponse);
        } catch (err) {
            console.error("ChatGPTBot error:", err);
            return new CommonResponseModel(false, 0, "Data Not Found", err);
        }
    }

    async convertFileAsync(fileUrl: string): Promise<string> {
        const PDF_CO_API_URL = 'https://api.pdf.co/v1';
        const API_KEY = 'jayanthpappala3@gmail.com_Hme01xNjpk6ed8ya7fXtbwwJJWe5hLozUhpa0LFiPXQiva1JrW3GEakVTIpLxF14';

        const response = await axios.post(
            `${PDF_CO_API_URL}/pdf/convert/to/text`,
            {
                name: 'result.txt',
                url: fileUrl,
                async: true
            },
            {
                headers: {
                    'x-api-key': API_KEY,
                    'Content-Type': 'application/json'
                }
            }
        );

        if (response.data.error) {
            throw new Error(response.data.message);
        }

        return response.data.jobId;
    }

    async checkJobStatus(jobId: string): Promise<string> {
        const PDF_CO_API_URL = 'https://api.pdf.co/v1';
        const API_KEY = 'jayanthpappala3@gmail.com_Hme01xNjpk6ed8ya7fXtbwwJJWe5hLozUhpa0LFiPXQiva1JrW3GEakVTIpLxF14';

        let attempts = 0;
        const maxAttempts = 30;
        const initialDelay = 1000;
        const maxDelay = 25000;
        while (attempts < maxAttempts) {
            attempts++;
            if (attempts > 1) {
                const delay = Math.min(initialDelay * Math.pow(2, attempts - 2), maxDelay);
                await new Promise(resolve => setTimeout(resolve, delay));
            }
            const statusResponse = await axios.get(
                `${PDF_CO_API_URL}/job/check`,
                {
                    params: { jobId },
                    headers: { 'x-api-key': API_KEY }
                }
            );
            if (statusResponse.data.error) {
                throw new Error(statusResponse.data.message);
            }
            if (statusResponse.data.status === 'success') {
                return statusResponse.data.url;
            }
            if (statusResponse.data.status === 'failed') {
                throw new Error(`Job failed: ${statusResponse.data.message}`);
            }
        }
        throw new Error('Job processing timeout exceeded');
    }

    async getPdfDataUsingAPI(filename: string): Promise<{ presignedUrl: string; url: string }> {
        const PDF_CO_API_URL = 'https://api.pdf.co/v1';
        const API_KEY = 'jayanthpappala3@gmail.com_Hme01xNjpk6ed8ya7fXtbwwJJWe5hLozUhpa0LFiPXQiva1JrW3GEakVTIpLxF14';
        const response = await axios.get(`${PDF_CO_API_URL}/file/upload/get-presigned-url`, {
            params: {
                contenttype: 'application/octet-stream',
                name: filename
            },
            headers: {
                'x-api-key': API_KEY
            }
        });

        if (response.data.error) {
            throw new Error(response.data.message);
        }

        return {
            presignedUrl: response.data.presignedUrl,
            url: response.data.url
        };
    }

    async uploadFile(fileBuffer: Buffer, presignedUrl: string): Promise<void> {
        await axios.put(presignedUrl, fileBuffer, {
            headers: {
                'Content-Type': 'application/octet-stream'
            }
        });
    }

    async convertFile(fileUrl: string): Promise<string> {
        const PDF_CO_API_URL = 'https://api.pdf.co/v1';
        const API_KEY = 'jayanthpappala3@gmail.com_Hme01xNjpk6ed8ya7fXtbwwJJWe5hLozUhpa0LFiPXQiva1JrW3GEakVTIpLxF14';
        const response = await axios.post(
            `${PDF_CO_API_URL}/pdf/convert/to/text`,
            {
                name: 'result.txt',
                url: fileUrl
            },
            {
                headers: {
                    'x-api-key': API_KEY,
                    'Content-Type': 'application/json'
                }
            }
        );
        if (response.data.error) {
            throw new Error(response.data.message);
        }
        return response.data.url;
    }

    async downloadTextFile(url: string): Promise<string> {
        const response = await axios.get(url);
        return response.data;
    }

    async savePdfExtractedData(req: any): Promise<CommonResponseModel> {
        try {
            const headersEntity = new HeadersEntity();
            headersEntity.customerNumber = req.jsonData.header.customerNumber;
            headersEntity.customerName = req.jsonData.header.customerName;
            headersEntity.customerPONo = req.jsonData.header.customerPONo;
            headersEntity.supplierName = req.jsonData.header.supplierName;
            headersEntity.currency = req.jsonData.header.currency;
            headersEntity.requestedDate = req.jsonData.header.requestedDate;
            headersEntity.deliveryMethod = req.jsonData.header.deliveryMethod;
            headersEntity.paymentTerms = req.jsonData.header.paymentTerms;
            headersEntity.shipTo = req.jsonData.header.shipTo;
            headersEntity.deliveryTerms = req.jsonData.header.deliveryTerms;
            headersEntity.packagingTerms = req.jsonData.header.packagingTerms;
            headersEntity.supplierReference = req.jsonData.header.supplierReference;
            headersEntity.pdfFileName = req.file.originalname;
            headersEntity.filePath = req.file.path;
            headersEntity.summary = req.summary;
            headersEntity.status = "SUCCESS";
            const saveHeaders = await this.HeadersRepository.save(headersEntity);
            if (!saveHeaders) {
                return new CommonResponseModel(false, 0, "Header data not saved");
            }

            for (const reqData of req.jsonData.lineItems) {
                const lineItemsEntity = new LineItemsEntity();
                lineItemsEntity.headerId = saveHeaders.id;
                lineItemsEntity.SNo = reqData.SNo;
                lineItemsEntity.itemDescription = reqData.itemDescription;
                lineItemsEntity.description1 = reqData.description1;
                lineItemsEntity.description2 = reqData.description2;
                lineItemsEntity.quantity = reqData.quantity;
                lineItemsEntity.unitMeasurement = reqData.unitMeasurement;
                lineItemsEntity.price = reqData.price;
                lineItemsEntity.priceUnit = reqData.priceUnit;
                lineItemsEntity.lineAmount = reqData.lineAmount;
                lineItemsEntity.itemNumber = reqData.itemNumber;

                const saveLineItems = await this.LineItemsRepository.save(lineItemsEntity);
                if (!saveLineItems) {
                    return new CommonResponseModel(false, 0, "Failed to save line items");
                }
            }
            return new CommonResponseModel(true, 1111, "Data Saved Successfully");
        } catch (err) {
            console.error("Error saving data:", err);
            return new CommonResponseModel(false, 0, "Data Not Saved Err", err);
        }
    }

    async getPdfInfoDetailedViewData(): Promise<CommonResponseModel> {
        try {
            const data = await this.HeadersRepository.getPdfNameCustomerNameRepo()
            if (data) {
                return new CommonResponseModel(true, 1, "Data Got", data)
            } else {
                return new CommonResponseModel(false, 0, "No Data")
            }
        } catch (err) {
            return new CommonResponseModel(false, 0, "Data Not Found", err)
        }
    }

    async getAllData(req): Promise<CommonResponseModel> {
        try {
            const data = await this.HeadersRepository.getAllDataRepo(req)
            if (data) {
                return new CommonResponseModel(true, 1, "Data Got", data)
            } else {
                return new CommonResponseModel(false, 0, "No Data")
            }
        } catch (err) {
            return new CommonResponseModel(false, 0, "Data Not Found", err)
        }
    }

    async createFeildMapping(req: any): Promise<CommonResponseModel> {
        try {
            const existingRecords = await this.FeildMappingRepository.find();
            if (existingRecords.length > 0) {
                const existingRecord = existingRecords[0];
                const availableFields = [
                    { key: 'customerNumber', label: 'Customer Number' },
                    { key: 'customerName', label: 'Customer Name' },
                    { key: 'customerPONo', label: 'Customer PO No' },
                    { key: 'supplierName', label: 'Supplier Name' },
                    { key: 'currency', label: 'Currency' },
                    { key: 'requestedDate', label: 'Requested Date' },
                    { key: 'deliveryMethod', label: 'Delivery Method' },
                    { key: 'paymentTerms', label: 'Payment Terms' },
                    { key: 'shipTo', label: 'Ship To' },
                    { key: 'deliveryTerms', label: 'Delivery Terms' },
                    { key: 'packagingTerms', label: 'Packaging Terms' },
                    { key: 'supplierReference', label: 'Supplier Reference' },
                    { key: 'SNo', label: 'S.No' },
                    { key: 'itemDescription', label: 'Item Description' },
                    { key: 'quantity', label: 'Quantity' },
                    { key: 'unitMeasurement', label: 'Unit Measurement' },
                    { key: 'price', label: 'Price' },
                    { key: 'priceUnit', label: 'Price Unit' },
                    { key: 'lineAmount', label: 'Line Amount' },
                    { key: 'itemNumber', label: 'Item Number' }
                ];
                for (const field of availableFields) {
                    if (req[field.key]) {
                        if (existingRecord[field.key]) {
                            existingRecord[field.key] = `${existingRecord[field.key]},${req[field.key]}`;
                        } else {
                            existingRecord[field.key] = req[field.key];
                        }
                    }
                }
                await this.FeildMappingRepository.save(existingRecord);
                return new CommonResponseModel(true, 1, "Data Updated Successfully");
            } else {
                const newEntity = new FeildMappingEntity();
                for (const [key, value] of Object.entries(req)) {
                    if (value) {
                        newEntity[key] = value;
                    }
                }
                const savedData = await this.FeildMappingRepository.save(newEntity);
                return new CommonResponseModel(true, 1, "Data Saved Successfully");
            }
        } catch (err) {
            console.error(err);
            return new CommonResponseModel(false, 0, "Data Not Saved");
        }
    }




}
